const styles = {
    close: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '16px',
        textAlign: 'center',
        borderRadius: 2,
        p: 2,
        color: '#3876AA',
        textTransform: 'none',
        borderWidth: '2px',
    },
    errorsDataContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    popupButtonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: '24px',
    },
    tryAgain: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '8px',
        textAlign: 'center',
        borderRadius: '16px',
        p: 2,
        color: 'white',
        textTransform: 'none',
        backgroundColor: '#ED0000',
        width: '50%',
    },
    exit: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '16px',
        textAlign: 'center',
        borderRadius: '16px',
        p: 2,
        color: '#3876AA',
        textTransform: 'none',
        mr: 2,
        borderColor: '#3876AA',
        borderWidth: '2px',
        width: '50%',
    },
    email: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        color: '#5C697B',
    },
};
export default styles;
